export { default } from './TruncateText';
